module.exports = __webpack_public_path__ + "static/media/chia_chen_lee.2f1f8487.jpg";